import * as Yup from 'yup';

export const signingOfTheStatusSchema = Yup.object().shape({
  actNature: Yup.string()
    .required('La nature de l’acte est obligatoire.')
    .min(3, 'La nature de l’acte doit comporter au moins 3 caractères.')
    .max(100, 'La nature de l’acte ne doit pas dépasser 100 caractères.'),
  actDate: Yup.string()
    .required('La date de l’acte est obligatoire.')
    .typeError('Veuillez fournir une date valide.'),
  placeSignature: Yup.string()
    .optional()
    .max(100, 'Le lieu de signature ne doit pas dépasser 100 caractères.')
});

export default signingOfTheStatusSchema;